module.exports = " <div class=work-info _v-35682fd0=\"\"> <h1 _v-35682fd0=\"\">{{ title }}</h1> <p _v-35682fd0=\"\">{{ subtitle }}</p> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-35682fd0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/WorkInfo.vue
 ** module id = 31
 ** module chunks = 1
 **/